import React, { useEffect, useState } from "react"
import { Col, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import { SaveButton } from "components/Buttons"
import { useSelector } from "react-redux"

const AxisCareSettings = ({
  metaTags,
  axisCareSetup,
  updateClientSettings,
}) => {
  const clientConfig = useSelector(state => state.Login.clientConfig)
  const [selectedTags, setSelectedTags] = useState([])
  const [apiToken, setApiToken] = useState("")
  const [siteNumber, setSiteNumber] = useState("")
  const [useStartDate, setUseStartDate] = useState(false)
  const [siteNumIsValid, setSiteNumIsValid] = useState(true)
  const [tokenIsValid, setTokenIsValid] = useState(true)
  const [hasToken, setHasToken] = useState(false)
  const [isTokenChanged, setIsTokenChanged] = useState(false)
  const MASKED_TOKEN = "***************"

  useEffect(() => {
    if (axisCareSetup) {
      const {
        axis_care_integration_default_date,
        axis_care_integration_site_number,
        axis_care_integration_tags,
        axis_care_integration_api_token,
        axis_care_integration_activated,
      } = axisCareSetup

      setSiteNumber(axis_care_integration_site_number)
      setUseStartDate(axis_care_integration_default_date !== "hireDate")
      setSelectedTags(
        Array.isArray(axis_care_integration_tags)
          ? axis_care_integration_tags.map(tagId => {
              const tag = metaTags?.find(x => x?.id === +tagId)
              if (!tag) return
              return {
                label: tag.tag,
                value: tag.id,
              }
            })
          : []
      )
      if (axis_care_integration_activated) {
        setApiToken(MASKED_TOKEN)
        setHasToken(true)
      }
    }
  }, [axisCareSetup, metaTags])

  const handleSubmit = () => {
    const isSiteNumberInvalid =
      siteNumber == null ||
      (typeof siteNumber === "string" && siteNumber?.trim()?.length === 0)
    const isTokenInvalid = !apiToken || apiToken?.trim()?.length === 0

    setSiteNumIsValid(!isSiteNumberInvalid)
    setTokenIsValid(!isTokenInvalid)

    if (isSiteNumberInvalid || isTokenInvalid) {
      return
    }

    updateClientSettings({
      updateLocalStorage: true,
      params: {
        ...axisCareSetup,
        axis_care_integration_tags: selectedTags,
        axis_care_integration_site_number: +siteNumber,
        axis_care_integration_default_date: useStartDate
          ? "startDate"
          : "hireDate",
        ...(apiToken === MASKED_TOKEN
          ? {}
          : { axis_care_integration_api_token: apiToken }),
      },
    })
  }

  return (
    <div>
      <Row className="mt-4">
        <Col>
          <Label for="siteNumber">AxisCare Site Number</Label>
          <Input
            id="siteNumber"
            value={siteNumber}
            onChange={event => {
              setSiteNumber(event.target.value)
              if (event.target.value) {
                setSiteNumIsValid(true)
              } else {
                setSiteNumIsValid(false)
              }
            }}
            placeholder="AxisCare Site Number"
            invalid={!siteNumIsValid}
            type="number"
            className="no-spin-number-input"
          />
          {!siteNumIsValid && (
            <FormFeedback>
              <div className="mt-3">AxisCare Site Number is required</div>
            </FormFeedback>
          )}
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Label for="axisCareApiToken">AxisCare Api Token</Label>
          <Input
            id="axisCareApiToken"
            name="axisCareApiToken"
            value={apiToken}
            onChange={event => {
              setApiToken(event.target.value)
              setIsTokenChanged(true)
              if (event.target.value) {
                setTokenIsValid(true)
              } else {
                setTokenIsValid(false)
              }
            }}
            placeholder="AxisCare Api Token"
            autoComplete="off"
            invalid={!tokenIsValid}
            style={{
              WebkitTextSecurity: "disc",
              MozTextSecurity: "disc",
            }}
            onFocus={() => {
              if (apiToken === MASKED_TOKEN) {
                setApiToken("")
              }
            }}
            onBlur={() => {
              if (apiToken?.trim() === "" && hasToken && !isTokenChanged) {
                setApiToken(MASKED_TOKEN)
              }
            }}
          />
          {!tokenIsValid && (
            <FormFeedback>
              <div className="mt-3">AxisCare Api Token is required</div>
            </FormFeedback>
          )}
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Label for="tags">AxisCare Tags</Label>
          <Select
            id="tags"
            value={selectedTags}
            isMulti={true}
            options={metaTags.map(tag => ({
              label: tag.tag,
              value: tag.id,
            }))}
            classNamePrefix="select2-selection"
            onChange={value => {
              setSelectedTags(value)
            }}
            menuPortalTarget={document.body}
            placeholder="Select tags"
          />
        </Col>
      </Row>

      {!!clientConfig && !!clientConfig?.rewards_enabled && (
        <Row className="mt-3">
          <Col>
            <Label for="rewards">Rewards</Label>
            <FormGroup check>
              <Input
                id="rewards"
                type="checkbox"
                checked={useStartDate}
                onChange={event => {
                  setUseStartDate(event.target.checked)
                }}
              />
              <Label check>
                Use start date (if available). If unchecked, "Hire Date" will be
                used.
              </Label>
            </FormGroup>
          </Col>
        </Row>
      )}
      <Row className="mt-2 d-flex justify-content-center">
        <Col xs="auto">
          <SaveButton type="button" content="Save" onClick={handleSubmit} />
        </Col>
      </Row>
    </div>
  )
}

export default AxisCareSettings
